module.exports = __webpack_public_path__ + "img/sixpackcarrier80.9ec64763.jpg";